'use strict';

var core = require('@capacitor/core');

const AppLauncher = core.registerPlugin('AppLauncher', {
    web: () => Promise.resolve().then(function () { return web; }).then(m => new m.AppLauncherWeb()),
});

class AppLauncherWeb extends core.WebPlugin {
    async canOpenUrl(_options) {
        return { value: true };
    }
    async openUrl(options) {
        window.open(options.url, '_blank');
        return { completed: true };
    }
}

var web = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AppLauncherWeb: AppLauncherWeb
});

exports.AppLauncher = AppLauncher;
//# sourceMappingURL=plugin.cjs.js.map
